// Milestone 1 Insight Workspace — shared labels, colors and helpers.
// The backend is authoritative for permissions/workflow/visibility; these maps are
// presentation only. Independent status domains are NEVER merged into one badge.

export const WORKFLOW = {
  draft: { label: "Draft", cls: "bg-slate-100 text-slate-600 border-slate-300" },
  submitted: { label: "Submitted", cls: "bg-brand-civic-50 text-brand-civic border-brand-civic/30" },
  in_review: { label: "In Review", cls: "bg-brand-gold-50 text-[#9A7212] border-brand-gold/40" },
  approved: { label: "Approved", cls: "bg-brand-teal-50 text-brand-teal border-brand-teal/30" },
  rejected: { label: "Returned for Revision", cls: "bg-amber-50 text-amber-700 border-amber-300" },
  denied: { label: "Denied", cls: "bg-red-50 text-red-600 border-red-200" },
};

export const AGENDA = {
  not_scheduled: "Not Scheduled", proposed: "Proposed", scheduled: "Scheduled", removed: "Removed",
};
export const PUBLICATION = {
  unpublished: "Unpublished", published: "Published", withdrawn: "Withdrawn",
};
export const CONSIDERATION = {
  not_considered: "Not Considered", under_consideration: "Under Consideration",
  deferred: "Deferred", concluded: "Concluded",
};
export const DECISION = {
  pending: "Pending", adopted: "Adopted", rejected: "Rejected", tabled: "Tabled", withdrawn: "Withdrawn",
};

// Visibility classes -> plain-language staff labels.
export const VISIBILITY = {
  staff_internal: { label: "Staff Only", cls: "bg-slate-100 text-slate-700 border-slate-300" },
  forum_authorized: { label: "Staff + Forum", cls: "bg-brand-civic-50 text-brand-civic border-brand-civic/30" },
  public: { label: "Public", cls: "bg-brand-teal-50 text-brand-teal border-brand-teal/30" },
};

export const EVENT_LABELS = {
  created: "created the Insight",
  content_updated: "updated the content",
  workflow_transition: "changed the workflow status",
  status_domain_change: "changed a status domain",
  attachment_added: "added an attachment",
};

export function isFinalized(wf) { return wf === "approved"; }
export function isEditableWorkflow(wf) { return wf === "draft" || wf === "rejected"; }
export function isTerminal(wf) { return wf === "approved" || wf === "denied"; }

export function fmtDateTime(s) {
  if (!s) return "—";
  try {
    return new Date(s).toLocaleString("en-US", {
      year: "numeric", month: "short", day: "numeric", hour: "numeric", minute: "2-digit",
    });
  } catch { return s; }
}

export function daysWaiting(s) {
  if (!s) return null;
  const d = Math.floor((Date.now() - new Date(s).getTime()) / 86400000);
  return isNaN(d) ? null : d;
}
